import { config } from "JS/Config";
import { BaseService } from "../BaseService";
import { BundleOptIn } from "JS/Models/BundleOptIn";
import { appConstants } from "JS/Helpers/Constants";

export class BundleOptInService extends BaseService {
    getBundleOptInStatus = () =>
        this.ngCall<BundleOptIn>(
            "get",
            appConstants.ngEndpoints.getBundleOptInStatus(config.user.memberId),
        );
}
